import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useLocation, useParams } from "react-router-dom";

import "./Annexure.scss";
import { Autocomplete, Button, TextField } from "@mui/material";
import AnneexureTable from "./AnnexureTable/AnneexureTable";
// import { useAnnexureData, useAuth } from "../../globalUtils/AuthProvider";
import { create } from "@mui/material/styles/createTransitions";
import { useImmer } from "use-immer";
import {
  getDataColumns,
  getFormattedRowData,
  getGroupIdsDropDownlist,
  getLast12Months,
  shouldShowAddButton,
} from "./annexureUtils";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

// import Loader from "../../globelComponents/Loader/Loader";
import AnnexureCrudPopup from "./AnnexureCrudPopup/AnnexureCrudPopup";
import { AnnexureContext } from "./annexureContext";
// import { getParsedLocalStorage } from "../../globalUtils/genricFunctions";
import toast from "react-hot-toast";
import axiosInstancePcdo from "../../pcdoAxiosInstance";
import { getParsedLocalStorage } from "../../../../Utils/storage-utils";
import { APP_BASE_URL_PCDO } from "../../../../Common/EndPoints";

const getAnnecureColumns = (content) => {
  let _cols = [];
  content.forEach((colObj) => {
    const { key, type, childs } = colObj;
    let _colObj = { key, childs, ...type };
    if (childs) {
      _colObj["childs"] = getAnnecureColumns(childs);
    }
    _cols.push(_colObj);
  });
  return _cols;
};

const defaultActionColumn = [
  {
    key: "action_1",
    childs: null,
    field: "action_col",
    label: "Actions",
    actionList: ["edit_act"],
    prefix: null,
    suffix: null,
    options: null,
    validator: null,
    is_editable: null,
  },
];

const initAnnexurePopupState = {
  open: false,
  rowId: false,
  initData: {},
  tableInstanceData: {},
};

const AnnexureView = ({
  annexureData,
  isTableLoading,
  annexureInfo,
  tableInstanceData,
}) => {
  // const {annexurePopupState, handleAnnexurePopupStateChange} = useContext(AnnexureContext)
  const [annexurePopupState, setAnnexurePopupState] = useImmer(
    initAnnexurePopupState
  );
  // const { userData } = useAuth();
  const userData = getParsedLocalStorage('pcdo_user_data')
  const { code, name, is_growable } = annexureData;
  const annexureColumns = getAnnecureColumns(
    annexureData?.header?.content ?? []
  );
  const tableRows = tableInstanceData?.parsedRow ?? [];

  const handleAdd = (annexureData) => {
    setAnnexurePopupState((prev) => {
      prev.open = true;
      prev.tableInstanceData = tableInstanceData;
    });
  };
  const handleTableActions = (action, rowData, col) => {
    if (action === "edit") {
      setAnnexurePopupState((prev) => {
        prev.open = true;
        prev.tableInstanceData = tableInstanceData;
        prev.rowId = rowData.id;
        prev.initData = rowData;
      });
    }
  };

  return (
    <div className="annexure-view ">
      <div className="annexure-header">
        <div className="annexure-label">
          {code} - {name}
        </div>
        {shouldShowAddButton(
          is_growable,
          annexureInfo,
          userData
        ) && (
            <Button onClick={() => handleAdd(annexureData)} variant="contained">
              Add
            </Button>
          )}
      </div>
      <div className="annexure-container">
        <AnneexureTable
          cols={[...defaultActionColumn, ...annexureColumns]}
          rows={tableRows}
          annexureInfo={annexureInfo}
          agg={annexureData.aggrigator}
          isTableLoading={isTableLoading}
          handleTableActions={handleTableActions}
        />
      </div>
      <div className="annexure-footer"></div>
      {annexurePopupState.open && (
        <AnnexureCrudPopup
          annexureCrudPopupState={annexurePopupState}
          annexureData={annexureData}
          onClose={() => {
            setAnnexurePopupState(initAnnexurePopupState);
          }}
        />
      )}
    </div>
  );
};



export const AnnexureWrapper = ({ annexureCode }) => {
  const annexureList = getParsedLocalStorage('pcdo_annexure_list')
  const groupsData = getParsedLocalStorage("pcdo_user_groupes");
  const userData = getParsedLocalStorage('pcdo_user_data')
  const annexureInfo = useMemo(() => {
    const _info = annexureList.find((ann) => ann.code === annexureCode);
    return _info;
  }, [annexureCode, annexureList]);
  const MONTH_DD = useMemo(() => {
    return getLast12Months(Date.now());
  }, []);


  const getFiltersList = (annInfo, userData) => {
    const { is_derived, derived_from } = annexureInfo;
    const roleName = userData.role.role;
    let _filterList = {
      selectedDate: { ddList: MONTH_DD },
    };
    const filterGroupIdsDD = getGroupIdsDropDownlist(
      userData.group.id,
      groupsData
    );
    if (is_derived) {
      if (derived_from === "ZONE") {
        if (roleName === "BOARD_MEM") {
          _filterList["filter_group_ids"] = {
            ddList: filterGroupIdsDD,
            label: "zone",
          };
          // add filter groupIds
        }
      }
      if (derived_from === "DIVISION") {
        if (roleName === "BOARD_MEM") {
          //for Borad member its childs will be zones
          _filterList["zone_id"] = {
            ddList: filterGroupIdsDD,
          };
          //it will be divisions
          _filterList["filter_group_ids"] = {
            ddList: [],
            label: "Division",
          };
        }
        if (roleName === "ZONE_MEM") {
          //filter_group_ids
          _filterList["filter_group_ids"] = {
            ddList: filterGroupIdsDD,
            label: "division",
          };
        }
      }
    }
    return _filterList;
  };

  const _filterList = useMemo(() => {
    console.log('userData', userData)
    return getFiltersList(annexureInfo, userData);
  }, [annexureInfo, userData]);

  return (
    <Annexure
      key={annexureInfo.id}
      filterList={_filterList}
      annexureInfo={annexureInfo}
    />
  );
};

const getInitalAnnexureFilters = (_filterList) => {
  let _initFilter = {};
  Object.entries(_filterList).forEach(([filterKey, filterInfo]) => {
    if (filterKey === "selectedDate") {
      const _selectedDateInLocal = localStorage?.getItem('annexure-month-filter') ?? null
      const { ddList } = filterInfo;
      console.log('_selectedDateInLocal', _selectedDateInLocal, ddList)
      let initSelectedDate = _selectedDateInLocal ? ddList.find((opt) => opt?.label === _selectedDateInLocal) : null
      _initFilter[filterKey] = { selectedValue: initSelectedDate ?? ddList[0], list: ddList };
    }
    if (filterKey === "filter_group_ids") {
      const { label, ddList } = filterInfo;
      _initFilter[filterKey] = {
        selectedValue: [],
        list: ddList,
        label: label,
      };
    }
    if (filterKey === "zone_id") {
      const { label, ddList } = filterInfo;
      _initFilter[filterKey] = { selectedValue: ddList[0], list: ddList };
    }
  });
  return _initFilter;
  // _filterList.forEach((filterInfo)=>{

  // })
};

function Annexure({ filterList, annexureInfo }) {

  const [annexureViewFilters, setAnnexureViewFilters] = useImmer(
    getInitalAnnexureFilters(filterList)
  );
  const [crudLoader, setCrudLoader] = useState(false);
  const [annexureDefination, setAnnexureDefinaction] = useImmer({
    isLoading: true,
    list: [],
  });
  const [annexureTableRowData, setAnnexureTableRowData] = useImmer({
    isLoading: true,
    data: {},
  });

  useEffect(() => {
    getAnnexureDefination(annexureInfo);
  }, []);
  const groupsData = getParsedLocalStorage("pcdo_user_groupes");
  useEffect(() => {
    getAnnexureTableRow(annexureInfo, annexureViewFilters);
  }, [annexureViewFilters, annexureInfo]);

  const getFilterGroupIdDDForZone = (selectedZoneId) => {
    const filterGroupIdsDD = getGroupIdsDropDownlist(
      selectedZoneId,
      groupsData
    );
    return filterGroupIdsDD;
  };

  const handleFilterChange = (filterKey, newValue) => {
    setAnnexureViewFilters((prev) => {
      prev[filterKey] = { ...prev[filterKey], selectedValue: newValue };
    });
    if (filterKey === 'selectedDate') {
      localStorage.setItem(`annexure-month-filter`, newValue.label)
    }
    if (filterKey === "zone_id") {
      setAnnexureViewFilters((prev) => {
        prev["filter_group_ids"] = {
          ...prev["filter_group_ids"],
          selectedValue: [],
        };
      });
      // getFilterGroupIdDDForZone(newValue.id)
    }
  };

  const getAnnexureDefination = (annexureInfo) => {
    setAnnexureDefinaction((prev) => {
      prev.isLoading = true;
    });
    const annexureId = annexureInfo.id ?? null;
    const url = `/annexure/definition/${annexureId}`;
    axiosInstancePcdo
      .get(url)
      .then((res) => {
        const _res = res.data.map((annxJson) => {
          return {
            id: annxJson.id,
            ...annxJson.definition,
          };
        });
        setAnnexureDefinaction((prev) => {
          prev.isLoading = false;
          prev.list = _res;
        });
      })
      .catch((err) => {
        setAnnexureDefinaction((prev) => {
          prev.isLoading = false;
          prev.list = [];
        });
      });
  };

  const getAnnexureTableRow = (annexureInfo, annexureFilter) => {
    setAnnexureTableRowData((prev) => {
      prev.isLoading = true;
      prev.data = {};
    });
    const url = `annexure/instance/${annexureInfo.id}`;
    const params = {
      date: annexureFilter.selectedDate?.selectedValue?.id ?? null,
      filter_group_ids:
        annexureFilter.filter_group_ids?.selectedValue
          ?.map((group) => group.id)
          .toString() ?? null,
      zone_id: annexureFilter.zone_id?.selectedValue?.id ?? null,
    };
    axiosInstancePcdo
      .get(url, { params })
      .then((res) => {
        const RES = res.data;
        const { grid_responses } = RES;
        const tableIdToDataMap = {};
        grid_responses.forEach((tableData) => {
          const { rows, grid_definition_id, ...rest } = tableData;

          let _parsedRows = [];
          if (rows) {
            _parsedRows = rows.map((row_data) => {
              const { row, ...rest } = row_data;
              const keyDataMap = {};
              row?.forEach((keyDataObj) => {
                let val = keyDataObj?.val ?? null;
                // if(val && Array.isArray(val)){
                //   val = val
                // }
                keyDataMap[keyDataObj?.key] = val;
              });
              return { ...rest, ...keyDataMap };
            });
          }
          tableIdToDataMap[grid_definition_id] = {
            grid_definition_id,
            ...rest,
            parsedRow: _parsedRows,
          };
        });
        setAnnexureTableRowData((prev) => {
          prev.isLoading = false;
          prev.data = tableIdToDataMap;
        });
      })
      .catch((err) => {
        setAnnexureTableRowData((prev) => {
          prev.isLoading = false;
          prev.data = {};
        });
      });
  };

  const handleSubmitData = (formJson, rowFieldData, popupStateData) => {
    const { rowId, tableInstanceData } = popupStateData;
    const formattedRowData = getFormattedRowData(
      getDataColumns([], formJson),
      rowFieldData
    );
    let url = `annexure/instance/row`;
    let apiCall = axiosInstancePcdo.post;

    if (rowId) {
      url = `${url}/${rowId}`;
      apiCall = axiosInstancePcdo.put;
    }

    const paramsBody = {
      cells: formattedRowData,
      grid_response_id: tableInstanceData?.id,
    };
    setCrudLoader(true);
    apiCall(url, paramsBody)
      .then((res) => {
        setCrudLoader(false);
        getAnnexureTableRow(annexureInfo, annexureViewFilters);
      })
      .catch((err) => {
        setCrudLoader(false);
      });
  };

  const handleExport = (annexureFilter) => {
    const url = `annexure/instance/${annexureInfo.id}`;
    const params = {
      date: annexureFilter.selectedDate?.selectedValue?.id ?? null,
      filter_group_ids:
        annexureFilter.filter_group_ids?.selectedValue
          ?.map((group) => group.id)
          .toString() ?? null,
      zone_id: annexureFilter.zone_id?.selectedValue?.id ?? null,
      is_export: true,
    };
    const toastId = toast.loading("Exporting...");
    axiosInstancePcdo
      .get(url, { params })
      .then((res) => {

        const filePath = res.data

        const downLoadrl = `${APP_BASE_URL_PCDO}/annexure/instance/export/${filePath}`;
        window.open(downLoadrl)
        toast.success("exported successfully", { id: toastId });
      })
      .catch((err) => {
        console.log("export", err);
        toast.error("Failed", { id: toastId });
      });
  };

  return (
    <AnnexureContext.Provider
      value={{
        annexureViewFilters,
        annexureDefination,
        annexureTableRowData,
        handleSubmitData,
      }}
    >
      <div className="annexures-container">
        <div className="annexure-container-header">
          <div className="annexure-view-filter-container">
            {annexureViewFilters?.selectedDate && (
              <Autocomplete
                id="annexure-date-filter"
                className="annexure-view-filter-input"
                options={annexureViewFilters?.selectedDate?.list}
                size="small"
                disableClearable
                getOptionLabel={(option) => option.label}
                value={annexureViewFilters?.selectedDate?.selectedValue ?? null}
                onChange={(event, newValue) => {
                  handleFilterChange("selectedDate", newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Month" size="small" />
                )}
              />
            )}
            {annexureViewFilters?.zone_id && (
              <Autocomplete
                id="annexure-zone-filter"
                className="annexure-view-filter-input"
                options={annexureViewFilters?.zone_id?.list}
                size="small"
                disableClearable
                getOptionLabel={(option) => option.label}
                value={annexureViewFilters?.zone_id?.selectedValue ?? null}
                onChange={(event, newValue) => {
                  handleFilterChange("zone_id", newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="ZONE" size="small" />
                )}
              />
            )}
            {annexureViewFilters?.filter_group_ids && (
              <Autocomplete
                id="annexure-filter_group_ids-filter"
                className="annexure-view-filter-input"
                multiple
                size="small"
                limitTags={2}
                // options={annexureViewFilters?.filter_group_ids?.list}
                options={
                  annexureViewFilters?.zone_id
                    ? getFilterGroupIdDDForZone(
                      annexureViewFilters?.zone_id?.selectedValue.id
                    ) ?? []
                    : annexureViewFilters?.filter_group_ids?.list
                }
                value={
                  annexureViewFilters?.filter_group_ids?.selectedValue ?? []
                }
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(opt, val) => opt.id === val.id}
                onChange={(event, value) => {
                  handleFilterChange("filter_group_ids", value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    label={annexureViewFilters?.filter_group_ids?.label ?? ""}
                  />
                )}
              />
            )}
          </div>
          <Button
            size="small"
            variant="contained"
            onClick={() => {
              handleExport(annexureViewFilters);
            }}
            startIcon={<FileDownloadOutlinedIcon />}
          >
            Export
          </Button>
        </div>
        {!annexureDefination.isLoading ? (
          annexureDefination.list.map((annexure, index) => {
            const grid_def_id = annexure.id;
            const isTableLoading = annexureTableRowData.isLoading;
            const tableInstanceData = annexureTableRowData.data[grid_def_id];


            return (
              <AnnexureView
                key={annexure.code}
                annexureData={annexure}
                annexureInfo={annexureInfo}
                isTableLoading={isTableLoading}
                tableInstanceData={tableInstanceData}
              />
            );
          })
        ) : (
          // <Loader />
          <div>Loading...</div>
        )}
        {crudLoader && <div>Loading...</div>}
      </div>
    </AnnexureContext.Provider>
  );
}

export default Annexure;
